import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps {
    align?: Parameters<typeof Text>[0]["align"];
}

export function LeadRodoTerms({align}: IProps) {
    const rodoTermsUrl = rpAppLink.rodoTerms.base();

    return (
        <Text as="span" variant="info_txt_3" color="var(--colors-gray-800)" align={align}>
            Administratorem danych osobowych świadczonych w związku z realizacja umowy jest Property Group sp. z o.o. –{" "}
            <Link href={rodoTermsUrl} target="_blank" textClassName={rodoLink}>
                zasady przetwarzania danych osobowych.
            </Link>
        </Text>
    );
}

const rodoLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline"
});
import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps {
    align?: Parameters<typeof Text>[0]["align"];
}

export function LeadRodoTerms({align}: IProps) {
    const rodoTermsUrl = rpAppLink.rodoTerms.base();

    return (
        <Text as="span" variant="info_txt_3" color="var(--colors-gray-800)" align={align}>
            Administratorem danych osobowych świadczonych w związku z realizacja umowy jest Property Group sp. z o.o. –{" "}
            <Link href={rodoTermsUrl} target="_blank" textClassName={rodoLink}>
                zasady przetwarzania danych osobowych.
            </Link>
        </Text>
    );
}

const rodoLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline"
});
